import React from 'react';
import { X } from 'lucide-react';

/**
 * Shared modal shell used by manage-categories create/rename/delete modals.
 * Kept in this folder for co-location with its only consumers.
 */
export default function ModalShell({ colors, onClose, title, children, testId }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-md rounded-2xl overflow-hidden"
        style={{ backgroundColor: colors.surface, border: `1px solid ${colors.border}` }}
        data-testid={testId}
      >
        <div className="flex items-center justify-between px-5 py-3 border-b" style={{ borderColor: colors.border }}>
          <h2 className="text-sm font-bold" style={{ color: colors.text }}>{title}</h2>
          <button onClick={onClose} style={{ color: colors.textMuted }}><X size={16} /></button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}
